export const getCloseIconPressHandler = (onClosePress: any) => {
  return (iconName: any) => {
    if (iconName === 'close') {
      onClosePress();
    }
  };
};
